import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "app-statuses-overview",
    templateUrl: "./statuses-overview.component.html",
    styleUrls: ["./statuses-overview.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StatusesOverviewComponent {}
